'use client';
import { jsx } from 'react/jsx-runtime';
import { useMenuTrigger } from '@react-aria/menu';
import { useMenuTriggerState } from '@react-stately/menu';
import { useTreeState } from '@react-stately/tree';
import { useRef, useMemo } from 'react';
import { useMenuList, SwanMenuListContext } from './menu-list.context.js';
import { useModeExtractor } from '../../hooks/use-mode-extractor/index.js';
import { SwanMenuTriggerContext } from './menu-trigger.context.js';
import { useCollectionContext } from '../../contexts/internal/collection/collection.context.js';
import { SwanPopoverContextProvider, useSwanPopover } from '../popover/popover.context.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function SwanMenuContextProviderInner(t) {
    let { children: a, onAction: l } = t, { triggerRef: b, triggerProps: f, overlayState: y } = useSwanPopover(), { menuTriggerProps: j, menuProps: _ } = useMenuTrigger(_object_spread_props(_object_spread({}, f), {
        type: 'menu'
    }), y, b), d = useMemo(()=>({
            triggerProps: j,
            triggerDisabled: false
        }), [
        j
    ]), O = useRef(null), { childItems: P, items: g, disabledKeys: v } = useCollectionContext(), w = useTreeState(_object_spread_props(_object_spread({}, _), {
        items: g,
        disabledKeys: v,
        children: P
    })), x = useMenuList(_object_spread_props(_object_spread({}, _), {
        onAction: l
    }), O, w);
    return jsx(SwanMenuTriggerContext.Provider, {
        value: d,
        children: jsx(SwanMenuListContext.Provider, {
            value: x,
            children: a
        })
    });
}
function SwanMenuContextProvider(r) {
    let o = useMenuTriggerState({}), p = useRef(null), i = useRef(null), s = useModeExtractor(i, o.isOpen);
    return jsx(SwanPopoverContextProvider, {
        value: useMemo(()=>({
                popoverRef: p,
                triggerRef: i,
                overlayState: o,
                overlayProps: {},
                triggerProps: {},
                modes: s
            }), [
            p,
            i,
            o,
            s
        ]),
        children: jsx(SwanMenuContextProviderInner, _object_spread({}, r))
    });
}

export { SwanMenuContextProvider };
